export const INVITE_PLAYER_ROUTE = {
  TITLE: 'Invite Players',
  ABSOLUTE_PATH: '/invite-players',
  EXACT_PATH: '/invite-players',
};
